import React from 'react';
import {Suggestions} from 'components';

export function Obstacles(props) {
  return (
    <Suggestions.List {...props}>
      <p>Don't have enough money</p>
      <p>Don't know enough</p>
      <p>It is too late for me</p>
      <p>Don't know what I want</p>
      <p>Don't have the right connections</p>
      <p>I am not focused</p>
      <p>I am a procrastinator</p>
      <p>Can't handle the stress</p>
      <p>Life is too complicated</p>
      <p>Don't believe in myself</p>
      <p>Don't know where to start</p>
    </Suggestions.List>
  );
}
